export enum PaymentMethod {
  Stripe = "stripe",
  HeyLight = "heylight",
}

export enum CheckoutPaymentMethod {
  StripeOneTime = "stripe_one_time",
  StripeInstallments = "stripe_installments",
  HeyLight = "hey_light",
}

export function getPaymentMethodName(method: PaymentMethod): string {
  switch (method) {
    case PaymentMethod.Stripe:
      return "Stripe";
    case PaymentMethod.HeyLight:
      return "HeyLight";
    default:
      return method;
  }
}

export function getPaymentMethodLabel(method: CheckoutPaymentMethod): string {
  switch (method) {
    case CheckoutPaymentMethod.StripeOneTime:
      return "In soluzione unica";
    case CheckoutPaymentMethod.StripeInstallments:
      return "A rate";
    case CheckoutPaymentMethod.HeyLight:
      return "Finanziamento";
    default:
      return method;
  }
}

export function getPaymentMethodDescription(
  method: CheckoutPaymentMethod,
): string {
  switch (method) {
    case CheckoutPaymentMethod.StripeOneTime:
      return "Pagamento immediato e sicuro";
    case CheckoutPaymentMethod.StripeInstallments:
      return "Pagamento in più rate";
    case CheckoutPaymentMethod.HeyLight:
      return "Pagamento tramite finanziaria";
    default:
      return "";
  }
}
